import { DigClientApp } from "@jari-tools/shared";
import type { AgeGroup } from "@jari-tools/shared";
import { readShareTokenFromPath, useShareSession } from "@jari-tools/shared";
import { createLocalDigStorage } from "../lib/local-storage";

const AGE_GROUPS: AgeGroup[] = ["8-11", "12-15", "16-18"];

function ageFromCfg(cfg: Record<string, unknown> | null): AgeGroup | null {
  const val = cfg?.ageGroup;
  if (typeof val === "string" && AGE_GROUPS.includes(val as AgeGroup)) {
    return val as AgeGroup;
  }
  return null;
}

export function SharePlayApp() {
  const { token, cfg } = useShareSession();
  const storage = createLocalDigStorage();

  return (
    <DigClientApp
      storage={storage}
      shareToken={token}
      ageGroupFromLink={ageFromCfg(cfg)}
      allowActivation={import.meta.env.DEV}
    />
  );
}
